import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Fullscreen image lightbox: click outside or press Esc to close.
 */
export const ImageLightbox = ({ src, alt = "", onClose }) => {
  useEffect(() => {
    if (!src) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [src, onClose]);

  return (
    <AnimatePresence>
      {src && (
        <motion.div
          data-testid="image-lightbox"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[100] bg-ink/95 backdrop-blur-sm flex items-center justify-center p-6 cursor-zoom-out"
        >
          {/* Close button */}
          <button
            onClick={onClose}
            data-testid="image-lightbox-close"
            aria-label="Close"
            className="absolute top-5 right-5 w-12 h-12 border border-[#333] text-bone hover:border-wood hover:text-wood font-mono text-2xl flex items-center justify-center"
          >
            ×
          </button>
          {/* Helper hint */}
          <div className="absolute top-5 left-5 font-mono text-[10px] tracking-tech text-bone/40">
            CLICK / ESC TO CLOSE
          </div>

          <motion.img
            src={src}
            alt={alt}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.2, 0.6, 0.1, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="max-w-[92vw] max-h-[88vh] object-contain"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ImageLightbox;
